import { useState } from "react";
import { sceneCompanions } from "@/mocks/quotes";

const sceneImages: Record<string, string> = {
  s1: "https://readdy.ai/api/search-image?query=Cozy%20dim%20bedroom%20corner%20at%20night%20with%20a%20warm%20bedside%20lamp%2C%20soft%20blanket%20and%20a%20book%2C%20muted%20beige%20and%20amber%20tones%2C%20quiet%20melancholic%20mood%2C%20gentle%20shadows%2C%20minimal%20editorial%20photography&width=900&height=1000&seq=longday-scene-s1-2026&orientation=portrait",
  s2: "https://readdy.ai/api/search-image?query=Late%20night%20lone%20window%20with%20city%20bokeh%20lights%20in%20the%20distance%2C%20deep%20warm%20brown%20tones%20with%20soft%20amber%20glow%2C%20silent%20solitary%20atmosphere%2C%20cinematic%20minimal%20composition%2C%20high%20detail&width=900&height=1000&seq=longday-scene-s2-2026&orientation=portrait",
  s3: "https://readdy.ai/api/search-image?query=Soft%20dawn%20light%20over%20a%20calm%20horizon%20seen%20from%20a%20window%2C%20pale%20warm%20cream%20and%20peach%20gradient%20sky%2C%20hopeful%20quiet%20mood%2C%20minimal%20artistic%20photography%2C%20gentle%20grain%2C%20high%20detail&width=900&height=1000&seq=longday-scene-s3-2026&orientation=portrait",
  s4: "https://readdy.ai/api/search-image?query=Rainy%20window%20with%20water%20droplets%20and%20blurred%20warm%20lights%20behind%2C%20muted%20terracotta%20and%20beige%20palette%2C%20calm%20melancholic%20rainy%20day%20mood%2C%20minimal%20editorial%20photography%2C%20soft%20focus&width=900&height=1000&seq=longday-scene-s4-2026&orientation=portrait",
};

export default function SceneCompanions() {
  const [activeId, setActiveId] = useState(sceneCompanions[0].id);
  const active = sceneCompanions.find((s) => s.id === activeId) ?? sceneCompanions[0];

  return (
    <section id="companion" className="w-full bg-background-100 py-16 md:py-24 scroll-mt-16">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-8">
        <div className="max-w-2xl">
          <span className="text-xs tracking-widest text-secondary-700 uppercase">Night Companion</span>
          <h2 className="mt-3 font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
            深夜陪伴：按时间找到属于你的那一段
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
            不同的时刻，情绪的重量不一样。选一个你现在所处的时间，读一读这个时段专属的几句陪伴，
            看看有没有一句正好说中你。
          </p>
        </div>

        <div className="mt-8 flex gap-2 overflow-x-auto pb-1" role="tablist" aria-label="深夜陪伴场景">
          {sceneCompanions.map((s) => {
            const isActive = s.id === activeId;
            return (
              <button
                key={s.id}
                type="button"
                role="tab"
                aria-selected={isActive}
                onClick={() => setActiveId(s.id)}
                className={`shrink-0 px-4 py-2.5 rounded-full text-sm transition-colors cursor-pointer whitespace-nowrap ${
                  isActive
                    ? "bg-secondary-500 text-background-50"
                    : "bg-background-50 border border-background-200/70 text-foreground-700 hover:bg-background-50/60"
                }`}
              >
                <span className="font-medium">{s.label}</span>
                <span className={`ml-2 text-xs ${isActive ? "text-background-100/80" : "text-foreground-500"}`}>
                  {s.time}
                </span>
              </button>
            );
          })}
        </div>

        <div className="mt-6 rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden grid grid-cols-1 lg:grid-cols-5">
          <div className="relative lg:col-span-2 h-56 sm:h-72 lg:h-auto lg:min-h-[420px]">
            <img
              src={sceneImages[active.id]}
              alt={`${active.label}时段的氛围配图`}
              title={`长日光阴 ${active.label} 陪伴文字`}
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
          </div>

          <div className="lg:col-span-3 p-6 md:p-10 flex flex-col">
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs w-fit">
              <i className="ri-moon-line"></i>
              {active.time}
            </span>
            <h3 className="mt-4 font-heading text-xl md:text-2xl font-semibold text-foreground-950">
              {active.title}
            </h3>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-700">{active.desc}</p>

            <ul className="mt-6 flex flex-col gap-3">
              {active.lines.map((line, i) => (
                <li
                  key={i}
                  className="flex items-start gap-3 rounded-lg bg-background-100 border border-background-200/60 px-4 py-3.5"
                >
                  <span className="shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 text-xs mt-0.5">
                    {i + 1}
                  </span>
                  <span className="font-heading text-sm md:text-base leading-relaxed text-foreground-900">
                    {line}
                  </span>
                </li>
              ))}
            </ul>

            <p className="mt-6 text-xs text-foreground-500 flex items-center gap-1.5">
              <i className="ri-heart-line"></i>
              读到这里，先深呼吸一次，你已经做得很好了。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}